
import { HStack, Button, Box } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import CompanyTable from "../components/companyTable";
import CompanyForm from "../components/companyForm";
import Dialog from "@shared/components/dialog";
import useCompanyPage from "@companies/hooks/useCompanyPage";

const CompanyPage = () => {
   const { 
        companies,
        selectedItem,
        isOpenDrawer,
        isOpenDialog,
        onCloseDilog,
        setIsOpenDrawer,
        onPressAddItem,
        onPressEditItem,
        onPressDeleteItem,
        onCreateCompany,
        onUpdateCompany,
        onDeleteCompany,
        onPressPlayStop
    } = useCompanyPage()

    return(
        <Box position="relative">
            <HStack position="sticky" h={14} top={14} zIndex={10} bg="gray.100" justifyContent="end">
                <Button 
                    size="md" 
                    colorScheme="blue" 
                    leftIcon={<IoAdd color="white" size={22}/>} 
                    onClick={onPressAddItem}
                >
                    Agregar
                </Button>
            </HStack>
            <Box mt={4}>
                <CompanyTable 
                    data={companies} 
                    onPressEdit={onPressEditItem} 
                    onPressDelete={onPressDeleteItem}
                    onPressPlayStop={onPressPlayStop}
                />
            </Box>
            <CompanyForm 
                isOpen={isOpenDrawer} 
                company={selectedItem} 
                onClose={setIsOpenDrawer} 
                onCreateCompany={onCreateCompany}
                onUpdateCompany={onUpdateCompany}
            />
            <Dialog 
                isOpen={isOpenDialog} 
                onClose={onCloseDilog} 
                onConfirm={onDeleteCompany} 
                title="Eliminar Empresa" 
                message="¿Desea eliminar la empresa?"
            />
        </Box>  
    )
}

export default CompanyPage;